var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-link",on:{"click":function($event){return _vm.cancelOrd(_vm.params)}}},[_vm._v("취소")])
}
var staticRenderFns = []

export { render, staticRenderFns }